export default __webpack_public_path__ + "static/media/logo.5fc3fdc1.PNG";